const findById = (array, id) => array.find(obj => obj.id === id);

export default findById;
